import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { config } from '../../config/const';
import './QuizGeneration.css';
import { toast } from 'react-toastify';

const QuizGeneration = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { title, storyId, generatedQuiz } = location.state || {};
  
  const [quiz, setQuiz] = useState(null);
  const [loading, setLoading] = useState(true);

  const parseQuizData = (text) => {
    try {
      const questions = JSON.parse(text);
      
      return questions.map(q => ({
        question: q.question,
        options: q.options,
        correctAnswer: q.answer
      }));
    } catch (error) {
      console.error('Error parsing quiz data:', error);
      return [];
    }
  };

  useEffect(() => {
    if (!location.state) {
      toast.error("Missing story data!");
      navigate('/');
      return;
    }

    if (!generatedQuiz) {
      toast.error("Missing quiz data!");
      navigateToStory();
      return;
    }

    const parsedQuiz = parseQuizData(generatedQuiz);
    setQuiz(parsedQuiz);
    setLoading(false);
  }, [location.state, generatedQuiz, navigate]);

  const navigateToStory = useCallback(() => {
    navigate(`/story/${storyId}`);
  }, [navigate, storyId]);

  const handleSaveQuiz = async () => {
    try {
      const baseUrl = config?.backend_url || 'http://localhost:3002';
      
      await Promise.all(quiz.map(q => 
        axios.post(`${baseUrl}/saveQuestion`, {
          storyId: storyId,
          question: q.question,
          answer: q.correctAnswer,
          options: q.options
        })
      ));
      toast.success("Quiz saved successfully!");
      navigateToStory();
    } catch (error) {
      console.error("Save quiz error:", error);
      toast.error("Failed to save quiz");
      navigateToStory();
    }
  };

  return (
    <>
      {loading ? (
        <div className="quiz-loader">
          <div className="spinner"></div>
          <p>Generating quiz...</p>
        </div>
      ) : (
        <div className="quiz-generation">
          <h2>{title} - Quiz</h2>
          
          <div className="quiz-questions">
            {quiz?.map((question, index) => (
              <div key={index} className="quiz-question">
                <h3>Question {index + 1}</h3>
                <p>{question.question}</p>
                
                <div className="quiz-options">
                  {question.options.map((option, optIndex) => (
                    <div 
                      key={optIndex} 
                      className={`quiz-option ${
                        option === question.correctAnswer ? 'correct' : ''
                      }`}
                    >
                      <span className="option-label">
                        {['a', 'b', 'c', 'd'][optIndex]})
                      </span>
                      <span className="option-text">{option}</span>
                      {option === question.correctAnswer && 
                        <span className="correct-marker">✓</span>
                      }
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="quiz-actions">
            <button 
              className="discard-quiz"
              onClick={navigateToStory}
            >
              Skip Quiz
            </button>
            <button 
              className="save-quiz"
              onClick={handleSaveQuiz}
            >
              Save Quiz
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default QuizGeneration;